import { CheckCircle2, Circle, Phone, Users as UsersIcon, ListTodo, Bell } from "lucide-react";
import { act } from "@/lib/hooks";
import { api, fdatetime } from "@/lib/api";

const ICONS = { call: Phone, meeting: UsersIcon, task: ListTodo, reminder: Bell };

export function ActivityTimeline({ rows, reload, can, testId = "activity-timeline" }) {
  const toggle = async (id) => { if (await act(() => api.post(`/crm/activities/${id}/toggle`))) reload(); };
  return (
    <ol className="space-y-0 px-5 py-4" data-testid={testId}>
      {rows.length === 0 && <li className="text-sm text-slate-400">No activities yet.</li>}
      {rows.map((a) => { const I = ICONS[a.type] || ListTodo; return (
        <li key={a.id} className="relative flex gap-3 border-l border-slate-200 pb-4 pl-5 last:pb-0" data-testid={`timeline-activity-${a.id}`}>
          <span className="absolute -left-[9px] top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-white"><I className="h-3.5 w-3.5 text-[#389F95]" /></span>
          <div className="min-w-0 flex-1">
            <div className={`text-sm ${a.done ? "text-slate-400 line-through" : "font-medium text-slate-900"}`}>{a.subject}</div>
            <div className="text-xs capitalize text-slate-500">{a.type} · {a.owner} · logged {fdatetime(a.created_at)}{a.due_at && ` · due ${fdatetime(a.due_at)}`}</div>
            {a.notes && <p className="mt-1 text-xs text-slate-600">{a.notes}</p>}
          </div>
          <button disabled={!can} onClick={() => toggle(a.id)} data-testid={`timeline-toggle-${a.id}`}>{a.done ? <CheckCircle2 className="h-5 w-5 text-emerald-500" /> : <Circle className="h-5 w-5 text-slate-300" />}</button>
        </li>); })}
    </ol>
  );
}
